// Alerts
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Breadcrumb
export const EDITAR_BREADCRUMB = 'EDITAR_BREADCRUMB';

// Loader
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

// Auth
export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const OBTENER_USUARIO_ERROR = 'OBTENER_USUARIO_ERROR';
export const LOGOUT = 'LOGOUT';
export const RECUPERAR_USUARIO = 'RECUPERAR_USUARIO';
export const RESTABLECER_USUARIO = 'RESTABLECER_USUARIO';

// Dashboard
export const DASHBOARD = {
    OBTENER: 'OBTENER_DASHBOARD'
};

// Locatarios
export const LOCATARIOS = {
    BUSCAR: 'BUSCAR_LOCATARIOS', 
    DETALLES: 'DETALLES_LOCATARIO', 
    EDITAR: 'EDITAR_LOCATARIO', 
    RENTAS: 'RENTAS_LOCATARIO', 
    ELIMINAR: 'ELIMINAR_LOCATARIO', 
    FILTROS: 'FILTRAR_LOCATARIOS', 
    USUARIOS: {
        BUSCAR: 'BUSCAR_USUARIOS_LOCATARIOS', 
        AGREGAR: 'AGREGAR_USUARIO_LOCATARIO', 
        DETALLES: 'DETALLES_USUARIO_LOCATARIO', 
        EDITAR: 'EDITAR_USUARIO_LOCATARIO', 
        ELIMINAR: 'ELIMINAR_USUARIO_LOCATARIO'
    }
};

// Clientes
export const CLIENTES = {
    BUSCAR: 'BUSCAR_CLIENTES',
    DETALLES: 'DETALLES_CLIENTE',
    MEMBRESIA: 'MEMBRESIA_CLIENTE',
    PAQUETES: 'PAQUETES_CLIENTE',
    PAGOS: 'PAGOS_CLIENTE',
    SALDO: 'SALDO_CLIENTE',
    ELIMINAR: 'ELIMINAR_CLIENTE',
    FILTROS: 'FILTRAR_CLIENTES'
};

// Usuarios
export const USUARIO = {
    BUSCAR: 'BUSCAR_USUARIOS', 
    AGREGAR: 'AGREGAR_USUARIO', 
    DETALLES: 'DETALLES_USUARIO', 
    EDITAR: 'EDITAR_USUARIO', 
    ELIMINAR: 'ELIMINAR_USUARIO', 
    FILTROS: 'FILTRAR_USUARIOS'
};

// Citas
export const CITAS = {
    BUSCAR: 'BUSCAR_CITAS', 
    BUSCAR_HORARIOS: 'BUSCAR_HORARIOS', 
    BUSCAR_CONTRATACIONES: 'BUSCAR_CONTRATACIONES', 
    AGREGAR: 'AGREGAR_CITA', 
    DETALLES: 'DETALLES_CITA', 
    EDITAR: 'EDITAR_CITA', 
    ELIMINAR: 'ELIMINAR_CITA', 
    FILTROS: 'FILTRAR_RESERVACIONES'
};

// Reportes
export const REPORTES = {
    BUSCAR_REQUERIMIENTOS: 'BUSCAR_REQUERIMIENTOS_REPORTES'
};

// Configuración
export const CONFIGURACION_SERVICIOS = {
    BUSCAR: 'BUSCAR_SERVICIOS', 
    AGREGAR: 'AGREGAR_SERVICIO', 
    DETALLES: 'DETALLES_SERVICIO', 
    EDITAR: 'EDITAR_SERVICIO', 
    ELIMINAR: 'ELIMINAR_SERVICIO'
};

export const CONFIGURACION_MEMBRESIAS = {
    BUSCAR: 'BUSCAR_MEMBRESIAS', 
    AGREGAR: 'AGREGAR_MEMBRESIA', 
    DETALLES: 'DETALLES_MEMBRESIA', 
    EDITAR: 'EDITAR_MEMBRESIA', 
    ELIMINAR: 'ELIMINAR_MEMBRESIA'
};

export const CONFIGURACION_PAQUETES = {
    BUSCAR: 'BUSCAR_PAQUETES', 
    AGREGAR: 'AGREGAR_PAQUETE', 
    DETALLES: 'DETALLES_PAQUETE', 
    EDITAR: 'EDITAR_PAQUETE', 
    ELIMINAR: 'ELIMINAR_PAQUETE'
};

export const CONFIGURACION_PERFIL = {
    EDITAR_PERSONAL: 'EDITAR_PERFIL_PERSONAL', 
    EDITAR_EMPRESARIAL: 'EDITAR_PERFIL_EMPRESARIAL'
};